export interface Space {
  id: string;
  name: string;
  caption: string;
  img: string;
  alt: string;
}

export const SPACES: Space[] = [
  {
    id: "gaming",
    name: "Gaming rooms",
    caption: "Controller and pixel rugs for battlestations",
    img: "https://images.unsplash.com/photo-1715279240000-9a50953e327d",
    alt: "Gaming room with a large TV and neon lighting",
  },
  {
    id: "bedroom",
    name: "Bedrooms",
    caption: "Soft bedside pieces in calm palettes",
    img: "https://images.unsplash.com/photo-1560185893-a55cbc8c57e8",
    alt: "Bedroom with a floral area rug beside the bed",
  },
  {
    id: "living",
    name: "Living rooms",
    caption: "Statement rugs as the room's centrepiece",
    img: "https://images.unsplash.com/photo-1783018563064-ce571a378294",
    alt: "Living room with a sofa and layered patterned rugs",
  },
  {
    id: "studio",
    name: "Creative studios",
    caption: "Logo rugs and desk pads that spark ideas",
    img: "https://images.unsplash.com/photo-1740710543611-80b658171bc3",
    alt: "Creative studio corner with an easel and paintbrushes",
  },
  {
    id: "gift",
    name: "Gift settings",
    caption: "Keepsake rugs for people you love",
    img: "https://images.unsplash.com/photo-1764764138818-0b22ab4d4023",
    alt: "Gift box wrapped in kraft paper tied with twine and greenery",
  },
];

export const HERO_IMG =
  "https://static.prod-images.emergentagent.com/jobs/c9d62ee0-78ef-4564-9dad-43220be7457a/images/86d9eabdf2e39de1ef53e2de9cba44c9f06b17b7e9bd4371b4dc3fba54800120.jpeg";

export const YARN_SPOOLS_IMG =
  "https://images.pexels.com/photos/13078628/pexels-photo-13078628.jpeg";
